import { useEffect, useState } from 'react'
import { UiState } from '../managers/UIManager'
import { getEnabledClients, ClientConfig } from '../config/clients'
import ExperienceDetail from '../components/ExperienceDetail'
import { useNavigate } from 'react-router-dom'

interface Props {
  state: UiState
  setTab: (tab: UiState['activeTab']) => void
}

const ROUTE_BY_CLIENT: Record<string, string> = {
  aana: '/aana',
  pioneers: '/pioneers',
  'freedom-fighters': '/freedom-fighters',
  rockardemo: '/rockardemo',
}

export default function ExploreScreen({ state, setTab }: Props) {
  const [query, setQuery] = useState('')
  const [detailClient, setDetailClient] = useState<ClientConfig | null>(null)
  const navigate = useNavigate()

  const clients = getEnabledClients()
  const filtered = clients.filter(c =>
    c.clientName.toLowerCase().includes(query.toLowerCase()) ||
    ((c as any).experienceItem?.title || '').toLowerCase().includes(query.toLowerCase())
  )

  const handleScanFromDetail = (clientId: string) => {
    setDetailClient(null)
    const route = ROUTE_BY_CLIENT[clientId]
    if (route) {
      navigate(route)
      return
    }
    setTab('scan')
  }

    useEffect(() => {
    if (state.activeTab === 'explore') {
      setDetailClient(null);
    }
  }, [state.activeTab, state.tabTapKey]);


  return (
    <div className="app-screen explore-screen">
      <div className="app-screen-header">
        <span className="app-screen-title">Explore</span>
      </div>

      <div className="app-screen-scroll">
        {/* Search bar */}
        <div className="explore-search-wrap">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            className="explore-search-input"
            placeholder="Search AR experiences…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          {query && (
            <button className="explore-search-clear" onClick={() => setQuery('')}>×</button>
          )}
        </div>

        {/* Results grid */}
        <div className="explore-grid">
          {filtered.map(client => (
            <button
              key={client.clientId}
              className="explore-card"
              onClick={() => setDetailClient(client)}
            >
              <div className="explore-card-img-wrap">
                <img
                  src={client.experienceItem?.thumbnail || '/rockarlogo.png'}
                  alt={client.clientName}
                  className="explore-card-img"
                />
                <div className="explore-card-gradient" />
                {client.experienceItem?.isFeatured && (
                  <span className="explore-featured-badge">Featured</span>
                )}
              </div>
              <div className="explore-card-info">
                <p className="explore-card-collab">{client.clientName.toUpperCase()}</p>
                <p className="explore-card-title">
                  {client.experienceItem?.title || client.clientName}
                </p>
                {/* stats for likes and comments, however they are randomized
                <div className="home-effect-stats" style={{ marginTop: 4 }}>
                  <span className="home-stat small">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="#E91E8C" stroke="none">
                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                    </svg>
                    {Math.floor(Math.random() * 5000 + 200).toLocaleString()}
                  </span>
                  <span className="home-stat small">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.45)" strokeWidth="2">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                    {Math.floor(Math.random() * 300 + 20)}
                  </span>
                </div>
                */}
              </div>
            </button>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="explore-empty">
            <p>No experiences match "{query}"</p>
          </div>
        )}
      </div>

      {detailClient && (
        <ExperienceDetail
          client={detailClient}
          onClose={() => setDetailClient(null)}
          onScan={() => handleScanFromDetail(detailClient.clientId)}
        />
      )}
    </div>
  )
}
